/**
 * This fields of cookies can hold dynamic variables in `{{my_variable}}` format.
 */
var DYNAMICS_SEARCH_IN = ["codeOptIn", "codeOptOut", "codeOnPageLoad"];
var DYNAMICS_VARIABLE_REGEXP = /{{([A-Za-z0-9_]+)}}/gm;
export * from "./apply";
export { DYNAMICS_SEARCH_IN, DYNAMICS_VARIABLE_REGEXP };